import axios from "axios";
import enurl from "@/api/environment";

const ROUTE_PERMISSIONS = {
  TransactionRoomBooking: ["Transaction RoomBooking"],
  ViewSchedule: ["Transaction RoomBooking"],
  Facility: ["Facility Management"],
  Zone: ["Zone Management"],
  Utility: ["Utility Management"],
  Location: ["Location Management"],
  Roompad: ["Room Pad"],
  ManageUser: ["User Management"],
  ManageRole: ["Role Management"],
  ManageOrder: ["ManageOrder", "Manage Order", "Order Management"],
  ManageOrderDetail: ["ManageOrder", "Manage Order", "Order Management"],
};

let cachedPermissions = null;
let pendingPermissions = null;
let permissionVersion = 0;

export function requiresAppPermission(routeName) {
  return !!ROUTE_PERMISSIONS[routeName];
}

export function canAccessRoute(permissionNames, routeName) {
  const required = ROUTE_PERMISSIONS[routeName];
  if (!required) return true;
  const names = new Set((permissionNames || []).map(name => String(name).trim().toLowerCase()));
  return required.some(name => names.has(name.toLowerCase()));
}

export function invalidateAppPermissions() {
  permissionVersion += 1;
  cachedPermissions = null;
  window.dispatchEvent(new Event("app-permissions-updated"));
}

export function loadAppPermissions(force = false) {
  const key = axios.defaults.headers.common.Authorization || "";
  const version = permissionVersion;
  if (!force && cachedPermissions?.key === key && Date.now() < cachedPermissions.expiresAt) {
    return Promise.resolve(cachedPermissions.names);
  }
  if (pendingPermissions?.key === key && pendingPermissions.version === version) return pendingPermissions.promise;

  const promise = axios.get(`${enurl.apiUrl}Permission/getPermisionAppByRoleID`, { timeout: 15000 })
    .then(response => {
      if (version !== permissionVersion || key !== (axios.defaults.headers.common.Authorization || "")) {
        return loadAppPermissions(true);
      }
      if (response.data.status !== 0 || !Array.isArray(response.data.data)) {
        throw new Error(response.data.message || "Unable to load permissions");
      }
      const names = response.data.data.map(item => item.appName).filter(name => typeof name === "string");
      cachedPermissions = { key, names, expiresAt: Date.now() + 15000 };
      return names;
    }).finally(() => {
      if (pendingPermissions?.promise === promise) pendingPermissions = null;
    });
  pendingPermissions = { key, version, promise };
  return promise;
}
